import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { onboardingAPI } from '../../services/api';

export const STAGE_LABELS = {
  new_entry: 'New Entry',
  tutor_suggestion: 'Tutor Suggestion',
  verification: 'Verification',
  demo_scheduled: 'Demo Scheduled',
  demo_review: 'Demo Review',
  class_started: 'Class Started',
};

export const STAGE_COLORS = {
  new_entry: 'blue',
  tutor_suggestion: 'purple',
  verification: 'orange',
  demo_scheduled: 'teal',
  demo_review: 'orange',
  class_started: 'green',
};

export default function Onboarding() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [records, setRecords] = useState([]);
  const [stage, setStage] = useState(searchParams.get('stage') || '');
  const [mode, setMode] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    const params = {};
    if (stage) params.stage = stage;
    if (mode) params.mode = mode;
    setLoading(true);
    onboardingAPI.list(params).then(({ data }) => setRecords(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [stage, mode]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="page">
      <div className="page-header">
        <h2>Student Onboarding</h2>
        <Link to="/onboarding/new" className="btn btn-primary">+ New Student</Link>
      </div>

      <div className="filter-bar">
        <select value={stage} onChange={(e) => setStage(e.target.value)}>
          <option value="">All Stages</option>
          {Object.entries(STAGE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <select value={mode} onChange={(e) => setMode(e.target.value)}>
          <option value="">All Modes</option>
          <option value="offline">Offline</option>
          <option value="online">Online</option>
        </select>
      </div>

      {loading ? <div className="page-loading">Loading...</div> : (
        <div className="card">
          <table className="data-table">
            <thead>
              <tr><th>Student</th><th>Class</th><th>Syllabus</th><th>Mode</th><th>Stage</th><th>Tutor</th><th></th></tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr><td colSpan={7} className="text-center text-muted">No onboarding records</td></tr>
              ) : records.map((r) => (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/onboarding/${r.id}`)}>
                  <td>{r.student_name}</td>
                  <td>{r.student_class || '—'}</td>
                  <td>{r.syllabus ? r.syllabus.toUpperCase() : '—'}</td>
                  <td><span className={`badge badge-${r.mode === 'online' ? 'blue' : 'teal'}`}>{r.mode}</span></td>
                  <td>
                    <span className={`badge badge-${STAGE_COLORS[r.stage]}`}>{STAGE_LABELS[r.stage]}</span>
                    {r.is_on_hold && <span className="badge badge-red ml-2">On Hold</span>}
                  </td>
                  <td>{r.assigned_tutor || r.suggested_tutor || '—'}</td>
                  <td><button className="btn btn-sm btn-ghost" onClick={(e) => { e.stopPropagation(); navigate(`/onboarding/${r.id}`); }}>Open</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
